import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight, Phone } from "lucide-react";
import { SectionLink, scrollToId } from "@/components/site/SectionLink";
import { PHONE_DISPLAY, PHONE_HREF } from "@/components/site/data";

export const Breadcrumb = ({ title, parent = <SectionLink hash="#services" className="hover:text-brand-blue" data-testid="breadcrumb-services">Services</SectionLink> }) => (
  <nav aria-label="Breadcrumb" data-testid="service-breadcrumb">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs font-medium text-brand-slate sm:text-sm">
      <li><Link to="/" className="hover:text-brand-blue" data-testid="breadcrumb-home">Home</Link></li>
      <li aria-hidden="true"><ChevronRight className="h-3.5 w-3.5" /></li>
      {title !== "Service Areas" && (
        <>
          <li>{parent}</li>
          <li aria-hidden="true"><ChevronRight className="h-3.5 w-3.5" /></li>
        </>
      )}
      <li aria-current="page" className="text-brand-navy" data-testid="breadcrumb-current">{title}</li>
    </ol>
  </nav>
);

export const ServiceHero = ({ service, content }) => (
  <section data-testid="service-hero" className="bg-white">
    <div className="mx-auto max-w-7xl px-5 pt-8 sm:px-8">
      <Breadcrumb title={service.title} />
    </div>
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 pb-16 pt-10 sm:px-8 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:pb-24 lg:pt-14">
      <div>
        <p className="eyebrow animate-fade-up">{service.title}</p>
        <h1 data-testid="service-hero-heading" className="mt-5 animate-fade-up font-heading text-4xl font-semibold leading-[1.12] tracking-tight text-brand-navy [animation-delay:80ms] sm:text-5xl">
          {content.h1}
        </h1>
        <p data-testid="service-hero-intro" className="mt-6 max-w-xl animate-fade-up text-base leading-relaxed text-brand-slate [animation-delay:160ms] md:text-lg">{content.intro}</p>
        <div className="mt-9 flex animate-fade-up flex-col gap-3 [animation-delay:240ms] sm:flex-row sm:items-center sm:gap-4">
          <a href="#quote" onClick={(e) => { e.preventDefault(); scrollToId("quote"); }} data-testid="service-hero-quote-button" className="btn-primary">
            Request a Quote <ArrowRight className="h-4 w-4" />
          </a>
          <a href={PHONE_HREF} data-testid="service-hero-call-button" className="btn-secondary">
            <Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}
          </a>
        </div>
      </div>
      <img src={service.image} alt={service.title} className="aspect-[4/3] w-full animate-fade-up rounded-2xl object-cover [animation-delay:200ms]" data-testid="service-hero-image" />
    </div>
  </section>
);
